module.exports = __webpack_public_path__ + "img/task-force-full.1fe346b6.png";